import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FileUploader, FileItem } from 'ng2-file-upload';
import { ISession } from '../../../models/session';
import { environment as config } from '../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { interval } from 'rxjs/observable/interval';
import { switchMap, takeUntil } from 'rxjs/operators';
import { IUploadStatus, VideoService } from '../video.service';
import { Subject } from 'rxjs/Subject';
import { AuthService } from '../../auth/auth.service';
import { l } from '@angular/core/src/render3';

@Component({
  selector: 'simple-file-upload',
  templateUrl: './simple-file-upload.component.html',
  styleUrls: ['./video-file-upload.component.scss']
})
export class SimpleFileUploadComponent implements OnInit, OnDestroy {
  public uploader: FileUploader;
  public error: string;
  public filename: string;
  public hasBaseDropZoneOver = false;
  public uploadStatus: IUploadStatus = null;

  @Input('accept') public accept: string;
  @Input('uploadButtonTitle') public uploadButtonTitle: string = 'Upload';
  @Input('placeholder') public placeholder: string;
  @Input('info') public info: string;

  @Output() public onUpload: EventEmitter<any> = new EventEmitter<any>();

  constructor(private translateService: TranslateService, private videoService: VideoService) {
    this.uploader = new FileUploader({
      isHTML5: true
    });
    this.uploader.onAfterAddingFile = (fileItem: FileItem) => {
      this.filename = fileItem.file.name;
      if (this.uploader.queue.length > 1) {
        this.uploader.removeFromQueue(this.uploader.queue[0]);
      }
    };
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public upload(): void {
    this.error = null;
    if (this.uploader.queue.length > 0) {
      this.onUpload.next(this.uploader.queue[0].file.rawFile);
    }
  }

  public canUpload(): boolean {
    return this.uploader.queue.length > 0 && !this.inProgressOrDone();
  }

  public cancel(): void {
    if (this.uploader.queue.length > 0) {
      this.uploader.queue[0].cancel();
    }
  }

  public canEditFilename(): boolean {
    return false;
  }

  public inProgressOrDone(): boolean {
    const item = this.uploader.queue[0];
    return item ? item.isReady || item.isUploading || item.isSuccess : false;
  }

  public isPreparing(): boolean {
    const item = this.uploader.queue[0];
    return item ? item.isUploading : false;
  }

  public reset(): void {
    this.error = '';
    this.filename = '';
    this.uploader.clearQueue();
  }

  ngOnInit() {}

  ngOnDestroy(): void {}
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/file-upload/simple-file-upload.component.ts